document.addEventListener('DOMContentLoaded', function () {

  console.log(window.shopCountry);

  const parentElement = document.querySelector('#HeaderMenu-frozen-pizzas');

  if (parentElement) {
    const spanElement = parentElement.querySelector('span');

    const anchorElement = document.createElement('a');
    
// Automatically appends the localized subfolder without duplicating slashes
anchorElement.href = `${window.Shopify?.routes?.root || '/'}pages/frozen-pizzas`.replace('//', '/');

    anchorElement.appendChild(spanElement);

    parentElement.appendChild(anchorElement);
  }

  
  const hoverElement = document.querySelector('.header__inline-menu>ul>li:nth-of-type(2)');
  
  const submenuHTML = `
    <div class="pizza-submenu">
    <ul role="list" tabindex="-1">
    <li class="nav-label">Pizza to Share</li>
    <li><a id="HeaderMenu-frozen-pizzas-stuffed-crust" href="/collections/red-baron%C2%AE-stuffed-crust-pizza" class="header__menu-item list-menu__item link link--text focus-inset caption-large">Stuffed Crust</a></li>   
      <li><a id="HeaderMenu-frozen-pizzas-classic-crust" href="/collections/classic-crust-pizza" class="header__menu-item list-menu__item link link--text focus-inset caption-large">Classic Crust</a></li>
      <li><a id="HeaderMenu-frozen-pizzas-brick-oven" href="/collections/red-baron%C2%AE-brick-oven-pizza" class="header__menu-item list-menu__item link link--text focus-inset caption-large">Brick Oven</a></li>
      <li><a id="HeaderMenu-frozen-pizzas-crunchtime" href="/collections/crunchtime" class="header__menu-item list-menu__item link link--text focus-inset caption-large">CRUNCHTIME™</a></li>
      <li><a id="HeaderMenu-frozen-pizzas-fully-loaded-hand-tossed" href="/collections/red-baron%C2%AE-fully-loaded%E2%84%A2-hand-tossed-pizza" class="header__menu-item list-menu__item link link--text focus-inset caption-large">Fully Loaded Hand Tossed Style</a></li>
      <li><a id="HeaderMenu-frozen-pizzas-thin-crispy" href="/collections/red-baron%C2%AE-thin-crispy-pizza" class="header__menu-item list-menu__item link link--text focus-inset caption-large">Thin &amp; Crispy</a></li>
      <li class="nav-label" style="margin-top:20px;">Pizza for One</li>
      <li><a id="HeaderMenu-frozen-pizzas-deep-dish-xl" href="/collections/deep-dish-xl-frozen-pizza" class="header__menu-item list-menu__item link link--text focus-inset caption-large">Deep Dish XL</a></li>
      <li><a id="HeaderMenu-frozen-pizzas-deep-dish-singles" href="/collections/red-baron%C2%AE-deep-dish-pizza-singles" class="header__menu-item list-menu__item link link--text focus-inset caption-large">Deep Dish Singles</a></li>
      <li><a id="HeaderMenu-frozen-pizzas-french-bread-singles" href="/collections/red-baron%C2%AE-french-bread-pizza" class="header__menu-item list-menu__item link link--text focus-inset caption-large list-menu__item--active" aria-current="page">French Bread Singles</a></li>
      <li><a id="HeaderMenu-frozen-pizzas-scrambles" href="/collections/breakfast-scrambles" class="header__menu-item list-menu__item link link--text focus-inset caption-large list-menu__item--active" aria-current="page">Breakfast Scrambles</a></li>  
      
      
    </ul>
    </div>
  `;

  hoverElement.insertAdjacentHTML('beforeend', submenuHTML);

  // Toggle 'active' class on hover
  hoverElement.addEventListener('mouseenter', function () {
    hoverElement.classList.add('active');
  });

  hoverElement.addEventListener('mouseleave', function () {
    hoverElement.classList.remove('active');
  });
});





